/* assets/base-consent.js (Pozzalume: barra pz-barra, piede .pz-piede__legale, nome dalla pagina, EUR)
   ORIGINE: assets/hhk-consent.js del tema di HH (pagina-bundle/fase2/g/FINALE/tema, congelato il 22/10/2026).
   COSA FA: banner dei cookie del tema. Chiede da se' e passa la scelta a Shopify con la Customer Privacy API
   (setTrackingConsent). Mai un si' di partenza: prima la scelta salvata qui (12 mesi, localStorage 'base.consent'),
   poi quella gia' data a Shopify (per esempio al checkout), altrimenti chiede. Revoca dal link nel piede.
   Meta e Clarity NON si caricano da qui: li accende e spegne base-track.js, che ascolta visitorConsentCollected.
   COSA HO TOLTO: nome, voce e tacche del villaggio, id della barra d'acquisto di HH, selettori del piede di HH,
   nome e valuta di riserva dell'evento Lead (ora il titolo della pagina e EUR).
   COSA VA CONFIGURATO:
     1. il blocco BASE_CONSENT_CFG qui sotto (id della barra fissa in basso, se esiste; selettori del piede);
     2. il link "Preferenze cookie" nel piede con l'attributo data-base-cookie-prefs (vedi base-legale.liquid);
     3. le stringhe base_consent.* in locales/it.json (vedi neutral/locales/base-it.json);
     4. window.BASE_TRACK.nome / .valuta dal tema (snippets/base-track.liquid).
   NON TOCCARE: la regola "analyticsProcessingAllowed() non basta" (fuori dalle regioni obbligate dice si' senza
   aver chiesto niente) e il ricaricamento della pagina quando un si' diventa no (le librerie gia' scaricate non
   si possono scaricare). */
var BASE_CONSENT_CFG = window.BASE_CONSENT_CFG || {
  barraId: 'pz-barra',              /* id della barra d'acquisto fissa in basso, se c'e' */
  piede1: '.pz-piede__legale',      /* dove mettere il bottone Cookie se manca il link data-base-cookie-prefs */
  piede2: 'footer'
};
(function () {
  'use strict';
  var win = window, doc = document, root = doc.documentElement;
  var box = doc.getElementById('base-consent');
  if (!box) { root.removeAttribute('data-base-own-consent'); return; }
  win.BASE_CONSENT_OK = true;
  root.setAttribute('data-base-own-consent', '1');
  var CHIAVE = 'base.consent', ANNO = 31536000;
  function qs(n) { return box.querySelector('[data-base-consent="' + n + '"]'); }
  var voci = qs('voci'), sa = qs('a'), sm = qs('m'), scegli = qs('scegli'), salva = qs('salva');
  var indietro = null, partito = false, apri = null;
  var mosso = !(win.matchMedia && win.matchMedia('(prefers-reduced-motion: reduce)').matches);
  if (mosso) { root.classList.add('base-consent-mosso'); }

  function leggi(k) { try { return win.localStorage.getItem(k); } catch (e) { return null; } }
  function scrivi(k, v) { try { win.localStorage.setItem(k, v); } catch (e) { /* finestra privata */ } }
  function interno() {
    var q = /[?&]base_internal=([01])/.exec(win.location.search);
    if (q) { return q[1] === '1'; }
    return leggi('base_internal') === '1';
  }
  function privacy() {
    var p = win.Shopify && win.Shopify.customerPrivacy;
    return p && typeof p.setTrackingConsent === 'function' ? p : null;
  }
  function detto(v) { return v === 'yes' || v === 'no'; }
  function adesso() {
    var c = null, v = null, cp = privacy();
    try { c = JSON.parse(leggi(CHIAVE) || 'null'); } catch (e) { c = null; }
    if (c && c.t && Date.now() / 1000 - c.t > ANNO) { c = null; }
    if (c) { return { serve: false, a: !!c.a, m: !!c.m, qui: true }; }
    if (cp && typeof cp.currentVisitorConsent === 'function') { try { v = cp.currentVisitorConsent(); } catch (e) { v = null; } }
    if (v && detto(v.analytics) && detto(v.marketing)) { return { serve: false, a: v.analytics === 'yes', m: v.marketing === 'yes' }; }
    return { serve: true, a: false, m: false };
  }
  function dici(cp, a, m, fatto) {
    try { cp.setTrackingConsent({ analytics: a, marketing: m, preferences: false, sale_of_data: m }, function () { if (fatto) { fatto(); } }); } catch (e) { if (fatto) { fatto(); } }
  }

  /* sulla pagina bundle la barra d'acquisto sta in basso: il biglietto sale sopra di lei, mai sopra i suoi tocchi */
  var giuTm = 0;
  function misuraGiu() {
    giuTm = 0;
    var b = doc.getElementById(BASE_CONSENT_CFG.barraId), h = 0;
    if (b) {
      var r = b.getBoundingClientRect(), s = win.getComputedStyle(b);
      if (s.display !== 'none' && s.visibility !== 'hidden' && r.height > 0 && r.top < win.innerHeight) { h = Math.max(0, Math.round(win.innerHeight - r.top)); }
    }
    root.style.setProperty('--base-consent-giu', h + 'px');
  }
  function guardaGiu() { if (!giuTm && !box.hidden) { giuTm = win.requestAnimationFrame(misuraGiu); } }

  function vociAperte(si) {
    voci.hidden = !si;
    scegli.hidden = si;
    scegli.setAttribute('aria-expanded', si ? 'true' : 'false');
    salva.hidden = !si;
  }
  function mostra(tutte) {
    var c = adesso();
    sa.checked = !c.serve && c.a;
    sm.checked = !c.serve && c.m;
    vociAperte(!!tutte);
    box.classList.remove('is-chiuso', 'is-dentro');
    misuraGiu();
    box.hidden = false;
    if (mosso) {
      box.classList.add('is-fuori');
      void box.offsetHeight;
      win.requestAnimationFrame(function () { box.classList.remove('is-fuori'); box.classList.add('is-dentro'); });
    } else { box.classList.add('is-dentro'); }
  }
  function nascondi() {
    if (!mosso) { box.hidden = true; vociAperte(false); return; }
    box.classList.add('is-chiuso');
    setTimeout(function () { box.classList.add('is-fuori'); }, 260);
    setTimeout(function () { box.hidden = true; box.classList.remove('is-fuori', 'is-chiuso', 'is-dentro'); vociAperte(false); }, 900);
  }

  /* un si' diventato no: via i cookie di primo livello di Meta e Clarity, sul dominio e sul dominio padre */
  function dimentica() {
    var h = win.location.hostname, p = h.split('.'), ds = ['', h, '.' + h];
    if (p.length > 2) { ds.push('.' + p.slice(-2).join('.')); }
    doc.cookie.split(';').forEach(function (kv) {
      var n = kv.split('=')[0].replace(/^\s+|\s+$/g, '');
      if (!/^(_fbp|_fbc|_clck|_clsk)$/.test(n)) { return; }
      ds.forEach(function (d) { doc.cookie = n + '=; Max-Age=0; path=/' + (d ? '; domain=' + d : ''); });
    });
  }
  function caricato(pezzo) { return !!doc.querySelector('script[src*="' + pezzo + '"]'); }

  /* chi si e' iscritto al registro prima di scegliere: il Lead aspetta il si' con il suo eventID, mai prima */
  function leadInAttesa() {
    if (!doc.querySelector('.base-news__done')) { return; }
    try {
      if (win.sessionStorage.getItem('base_lead') === '1' || win.sessionStorage.getItem('base_consent.lead')) { return; }
      win.sessionStorage.setItem('base_consent.lead', 'base-consent-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8));
    } catch (e) { /* senza storage */ }
  }
  function leadDopoIlSi(m) {
    var id = null;
    try { id = win.sessionStorage.getItem('base_consent.lead'); } catch (e) { id = null; }
    if (!id || !m) { return; }
    setTimeout(function () {
      var T = win.BASE_TRACK || {};
      try {
        if (win.sessionStorage.getItem('base_lead') === '1') { win.sessionStorage.removeItem('base_consent.lead'); return; }
        if (typeof win.fbq !== 'function') { return; }
        win.sessionStorage.setItem('base_lead', '1');
        win.sessionStorage.removeItem('base_consent.lead');
        win.fbq('track', 'Lead', { content_name: T.nome || document.title, currency: T.valuta || 'EUR', value: 0 }, { eventID: id });
      } catch (e) { /* lo strumento non c'e' */ }
    }, 1200);
  }

  function scegliQuesto(a, m) {
    var cp = privacy(), prima = adesso(), b = indietro, via = false;
    var tolto = (caricato('clarity.ms') && !a) || (caricato('fbevents') && !m);
    function ricarica() { if (!via) { via = true; win.location.reload(); } }
    scrivi(CHIAVE, JSON.stringify({ a: a ? 1 : 0, m: m ? 1 : 0, t: Math.floor(Date.now() / 1000) }));
    if (cp) { dici(cp, a, m, tolto ? ricarica : null); }
    if ((prima.a && !a) || (prima.m && !m)) { dimentica(); }
    nascondi();
    indietro = null;
    if (b && doc.body.contains(b)) { b.focus(); }
    if (tolto) { setTimeout(ricarica, cp ? 1500 : 150); return; }
    leadDopoIlSi(m);
  }

  /* scelta gia' data qui ma non (piu') a Shopify: si ripassa una volta per sessione, cosi' la rispetta anche il checkout */
  function ripassa() {
    var cp = privacy(), c = adesso(), v = null;
    if (!cp || !c.qui || typeof cp.currentVisitorConsent !== 'function') { return; }
    try { if (win.sessionStorage.getItem('base_consent.sync')) { return; } win.sessionStorage.setItem('base_consent.sync', '1'); } catch (e) { return; }
    try { v = cp.currentVisitorConsent(); } catch (e) { v = null; }
    if (v && detto(v.analytics) && detto(v.marketing) && (v.analytics === 'yes') === c.a && (v.marketing === 'yes') === c.m) { return; }
    dici(cp, c.a, c.m, null);
  }

  /* il bottone "Cookie" nel piede: riapre la scelta con le preferenze di adesso */
  function mettiApri() {
    /* dove il piede ha il link "Preferenze cookie" (snippets/base-legale.liquid), e' lui a riaprire la scelta */
    var baseCollegati = doc.querySelectorAll('[data-base-cookie-prefs]');
    if (baseCollegati.length) {
      for (var i = 0; i < baseCollegati.length; i++) {
        (function (a) {
          a.setAttribute('aria-controls', 'base-consent');
          a.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); indietro = a; mostra(true); setTimeout(function () { sa.focus(); }, 30); });
        })(baseCollegati[i]);
      }
      apri = baseCollegati[0];
      return;
    }
    var dove = doc.querySelector(BASE_CONSENT_CFG.piede1) || doc.querySelector(BASE_CONSENT_CFG.piede2), fs = doc.querySelectorAll('footer');
    if (!dove && fs.length) { dove = fs[fs.length - 1]; }
    apri = doc.createElement('button');
    apri.type = 'button';
    apri.className = 'base-consent-apri';
    apri.setAttribute('aria-controls', 'base-consent');
    apri.textContent = box.getAttribute('data-base-consent-apri') || 'Cookie';
    if (dove) {
      var p = doc.createElement('p');
      p.className = 'base-consent-apri-p';
      p.appendChild(apri);
      dove.appendChild(p);
    } else {
      var riga = doc.createElement('p');
      riga.className = 'base-consent-apri-riga';
      riga.appendChild(apri);
      box.parentNode.insertBefore(riga, box);
    }
    apri.addEventListener('click', function () { indietro = apri; mostra(true); setTimeout(function () { sa.focus(); }, 30); });
  }

  qs('si').addEventListener('click', function () { scegliQuesto(true, true); });
  qs('no').addEventListener('click', function () { scegliQuesto(false, false); });
  scegli.addEventListener('click', function () { vociAperte(true); sa.focus(); });
  salva.addEventListener('click', function () { scegliQuesto(!!sa.checked, !!sm.checked); });
  /* riaperto dal piede, Esc chiude senza cambiare niente */
  box.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.key === 'Esc') && indietro) { var b = indietro; indietro = null; nascondi(); b.focus(); }
  });
  win.addEventListener('scroll', guardaGiu, { passive: true });
  win.addEventListener('resize', guardaGiu);
  /* la barra entra in ritardo (animazione di ingresso): si rimisura quando ha finito */
  var barra = doc.getElementById(BASE_CONSENT_CFG.barraId);
  if (barra) {
    barra.addEventListener('animationend', guardaGiu);
    barra.addEventListener('transitionend', guardaGiu);
    setTimeout(guardaGiu, 1600);
    setTimeout(guardaGiu, 3200);
  }

  /* tastiera su schermo: solo i campi che la aprono, mai caselle e interruttori (se no il biglietto sparisce al tocco) */
  function campo(el) { return !!el && (el.tagName === 'TEXTAREA' || el.tagName === 'SELECT' || (el.tagName === 'INPUT' && !/^(checkbox|radio|button|submit|reset|range|color|file|image|hidden)$/i.test(el.type || ''))); }
  doc.addEventListener('focusin', function (e) { if (campo(e.target)) { root.setAttribute('data-base-consent-kb', '1'); } });
  doc.addEventListener('focusout', function () { setTimeout(function () { if (!campo(doc.activeElement)) { root.removeAttribute('data-base-consent-kb'); } }, 60); });

  function parti() {
    if (partito) { return; }
    partito = true;
    ripassa();
    if (adesso().serve && !interno()) { leadInAttesa(); mostra(false); }
  }
  mettiApri();
  var S = win.Shopify;
  if (S && !privacy() && typeof S.loadFeatures === 'function') {
    try { S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { parti(); }); } catch (e) { /* si parte comunque */ }
    setTimeout(parti, 2500);
  } else { parti(); }
})();
